document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  /*
   * Get pathname only.
   *
   * Examples:
   * https://gypsophila.shop/
   * -> /
   *
   * https://gypsophila.shop/products
   * -> /products
   *
   * https://gypsophila.shop/products/1450?variant=123
   * -> /products/1450
   */
  let path = window.location.pathname;

  /*
   * Remove trailing slash except for homepage.
   *
   * /products/
   * -> /products
   */
  if (path.length > 1) {
    path = path.replace(/\/+$/, '');
  }

  /*
   * Remove classes first in case this script
   * gets executed again.
   */
  body.classList.remove(
    'top',
    'products',
    'product-list',
    'product-detail'
  );

  /*
   * Homepage
   */
  if (path === '/') {
    body.classList.add('top');
    return;
  }

  /*
   * Product listing page
   *
   * https://gypsophila.shop/products
   */
  if (path === '/products') {
    body.classList.add(
      'products',
      'product-list'
    );

    return;
  }

  /*
   * Product detail page
   *
   * https://gypsophila.shop/products/1450
   */
  if (path.startsWith('/products/')) {
    body.classList.add(
      'products',
      'product-detail'
    );

    return;
  }
});